export function parseCategoryName(categoryList) {
    for (let index = 0; index < categoryList.length; index++) {
        categoryList[index].parsedName = `${categoryList[index].id}-${categoryList[index].name}`;
    }

    return categoryList;
}

export function getHost() {
    let { origin } = location;
    return `${origin}`;
}
